import {
  TabTitleDisplayStrategy,
  WorkspaceTab,
} from '@ansys-internal/awf-angular/contributions';
import { ConceptEnum } from './enums/concept.enum';
// import { ConceptService } from '../../shared/services/concept.service';
import {
  DesignApiService,
  ProjectServiceApiService,
} from '@ansys/cloud-angular-client';
import { lastValueFrom } from 'rxjs';
import { AWFTab } from '@ansys-internal/awf-angular/core';
import { ConceptLayoutComponent } from '../../../components/layout/concept-layout/concept-layout.component';
import { VehicleSection } from './sections/configurations-section/configurations-section';
import { ComponentSection } from './sections/component-section/component-section';
import { ArchitectureSection } from './sections/architecture-section/architecture-section';
import { RequirementsSection } from './sections/requirement-section/requirement-section';
import { ConceptLayout } from '../../layouts/concept.layout';
import { ActivatedRoute } from '@angular/router';

@AWFTab({
  path: ConceptEnum.TAB_TYPE,
  displayStrategy: TabTitleDisplayStrategy.TEXT,
  closable: true,
  cacheable: false,
  layout: {
    default: {
      layout: ConceptLayout,
      components: {
        content: ConceptLayoutComponent,
      },
    },
  },
  children: [
    VehicleSection,
    ComponentSection,
    ArchitectureSection,
    RequirementsSection,
  ],
})
export class ConceptTab {
  type: string = ConceptEnum.TAB_TYPE;
  public title = 'Concept';
  public urlParamKeys = ['instanceId'];

  constructor(
    private designService: DesignApiService,
    private projectService: ProjectServiceApiService,
    private activeRoute: ActivatedRoute
  ) {}

  async getTitle(tab: WorkspaceTab): Promise<string> {
    let project;
    if (tab?.userData) {
      const instance = await lastValueFrom(
        this.designService.designInstanceLoadHandler({
          designInstanceId: tab?.userData?.['urlTree'][2] as string,
        })
      );
      project = await lastValueFrom(
        this.projectService.getProject(instance?.projectId as string)
      );
    }
    return project?.projectTitle ?? this.title;
  }

  canActivate(): boolean {
    return true;
  }
}
